import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  Renderer2
} from '@angular/core';
import {
  AccordionType,
  CaretType,
  PositionType
} from '../../../types/common.types';

@Component({
  selector: 'idp-accordion',
  templateUrl: './accordion.component.html',
  styleUrls: ['./accordion.component.scss']
})
export class AccordionComponent implements OnChanges {
  @Input() hideLabel = 'Hide Details';
  @Input() id = 'accordionBtn';
  @Input() showLabel = true;
  @Input() state = false;
  @Input() targetContent = 'modalBody';
  @Input() modalTitle = '';
  @Input() viewLabel = 'View Details';
  @Input() caretType: CaretType = 'primary';
  @Input() type: AccordionType = 'primary';
  @Input() positionType: PositionType = 'right';
  @Input() index = '_0';
  @Output() accordionClick = new EventEmitter<boolean>();
  targetText = this.viewLabel;

  constructor(private renderer: Renderer2, private cdf: ChangeDetectorRef) {}

  ngOnChanges() {
    this.toggleModal(this.state);
  }

  toggleModal(state: boolean): void {
    this.accordionClick.emit(this.state);
    this.targetText = state ? this.hideLabel : this.viewLabel;
    if (this.targetContent && this.targetContent !== '') {
      this.toggleModTargetElem(state);
      this.toggleModQuerySelect(state);
    }
    this.state = state;
    this.cdf.detectChanges();
  }

  toggleModTargetElem(state: boolean): void {
    const targetElement = document.getElementById(this.targetContent);
    if (targetElement) {
      state
        ? this.renderer.addClass(targetElement, 'show')
        : this.renderer.removeClass(targetElement, 'show');
    }
  }

  toggleModQuerySelect(state: boolean): void {
    const querySelectors = document.querySelectorAll(`.${this.targetContent}`);
    if (querySelectors && querySelectors.length > 0) {
      const displayVal = state ? 'block' : 'none';
      querySelectors.forEach((el: Element) => {
        if (el instanceof HTMLElement) {
          el.style.display = displayVal;
        }
      });
    }
  }
}
